import { getRecommendedFoods } from "services/recommendedFoodsService"
import * as types from "../types/recommendedFoods"

export const fetchRecommendedFoods = (branchId) => (
  async (dispatch) => {
    try {
      const response =
        await getRecommendedFoods({ branchId })

      dispatch({
        type: types.FETCH_RECOMMENDED_FOODS,
        recommendedFoods: response
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const addRecommendedFoods = (addedRecommendedFoods) => ({
  type: types.ADD_RECOMMENDED_FOODS,
  addedRecommendedFoods
})

export const updateRecommendedFoods = (updatedRecommendedFoods) => ({
  type: types.UPDATE_RECOMMENDED_FOODS,
  updatedRecommendedFoods
})

export const deleteRecommendedFoods = () => ({
  type: types.DELETE_RECOMMENDED_FOODS
})